<style scoped lang="less">
/deep/ .el-upload-list__item {
	div {
		width: auto;
		height: 100%;
	}
}

/deep/ .el-tag {
	background-color: #ecf5ff !important;
	// color: #fff;
	color: #409eff;
	border-color: #d9ecff;
}

/deep/ .el-carousel__indicators {
	display: none;
}

.is-selected {
	color: #1989fa;
}

.clickrooms {
	border: 1px solid;
	background-color: #028ecf;
	padding: 0.2rem 1rem;
	width: 5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10%;
	margin-left: 1.5%;
	color: #fff;
}

.el-carousel {
	height: 100%;

	/deep/ .el-carousel__container {
		height: 100%;
	}
}

.xqlist {
	display: flex;
	align-items: flex-start;
	flex-wrap: wrap;
	overflow: hidden;
	margin-bottom: 1rem;

	.xqtitlelb {
		height: 44vh;
	}

	// width: 80%;
	.xqtitlecontent {
		border-left: 2rem solid transparent;
		box-sizing: border-box;
		text-align: left;

		.contenttitile {
			color: #333;
			font-size: 1.4rem;
			font-weight: 700;
		}

		.contenttag {
			margin: 0.4rem 0;

			span {
				margin: 0 0.4rem 0 0;
			}
		}

		.contentlable {
			margin: 0.4rem 0 0 0;
			text-align: left;
			height: 2rem;
			font-size: 0.8rem;
			line-height: 2rem;

			p {
				height: 100%;
				display: flex;
				align-items: center;
			}

			span {
				font-family: '微软雅黑';
				font-weight: 400;
				font-style: normal;
				color: #777777;
			}

			span:first-child {
				display: block;
				width: 5.6vw;
				color: #333;
				font-size: 700;
				font-size: 0.8rem;
				font-weight: 600;
			}

			span:nth-of-type(2) {
				margin-left: 1rem;
			}

			.mordel {
				border: 1px solid;
				padding: 0 1rem;
				background-color: #0acf97;
				color: #fff;
				border-radius: 15px;
				font-size: 0.8vw;
				height: 1.5rem;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.coloses {
				background-color: #ff0000;
			}

			.spjkmop {
				background-color: #ff8300;

				::before {
					color: #fff !important;
				}
			}

			.nonlo {
				background-color: #cccccc;
			}
		}

		.testsm {
			padding: 1rem 0;
			padding-bottom: 2rem;
			// border-top: 1px solid #ccc;
			border-bottom: 1px solid #ccc;
			font-size: 0.8rem;
			margin: 0.4rem 0;
			/* 超出部分省略号 */
			overflow: hidden;
			text-overflow: ellipsis;
			word-break: break-all;
			/* break-all(允许在单词内换行。) */
			display: -webkit-box;
			/** 对象作为伸缩盒子模型显示 **/
			-webkit-box-orient: vertical;
			/** 设置或检索伸缩盒对象的子元素的排列方式 **/
			-webkit-line-clamp: 5;
			/** 显示的行数 **/
		}
	}
}

.roomstabs {
	width: 100%;
	// background-color: #fff;
	padding: 0 0 1rem;

	.roomchoes {
		display: flex;
		align-items: center;
		background: #ffffff;
		width: 55%;
		height: 5vh;
		line-height: 5vh;
		text-align: center;
		justify-content: space-around;

		li {
			width: 100%;
			height: 100%;
			border: 1px solid #e8e8e8;
			border-radius: 4px;
			color: #333;
			font-size: 1rem;
			overflow: hidden;
		}

		li:hover {
			background: #dddddd;
		}

		.tabsclass {
			border-bottom: none;
		}
	}

	.tabslist1 {
		background-color: #fff;
		padding: 1rem;
		box-sizing: border-box;
		border-left: 1px solid #e8e8e8;
		// border-left: 1px solid #e8e8e8;
		box-shadow: 10px 10px 0 0 #eff2fa;
	}

	/deep/ .el-tabs--border-card {
		padding: 0;
	}
}

.el-row {
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}
}

.el-col {
	border-radius: 4px;
}

.bg-purple-dark {
	background: #99a9bf;
}

.bg-purple {
	background: #d3dce6;
}

.bg-purple-light {
	background: #e5e9f2;
}

.grid-content {
	border-radius: 4px;
	min-height: 36px;
}

.roomszt {
	margin: 1rem 0;
	padding: 1rem 0;
	border-top: 1px solid #ccc;
	// border-bottom: 1px solid #ccc;

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #fe8930;
		background: #fe8930;
	}

	/deep/ .el-radio__input.is-checked + .el-radio__label {
		color: #333;
	}
}

.titlwrooms {
	font-size: 1.2rem;
	color: #333333;
	margin-bottom: 1rem;
}

.save {
	border-top: 1px solid #ccc;
	margin-top: 30px;

	.savenone {
		background-color: rgba(58, 181, 74, 1);
		width: 6rem;
		height: 2.6rem;
		margin: 1rem;
		color: #fff;
		border-radius: 5px;
		font-size: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.savenone:hover {
		background-color: rgba(71, 221, 86, 1);
		color: #0c3d3d;
		// font-weight: 600;
	}
}

.roomjj {
	p {
		overflow: inherit;
		white-space: pre-wrap;
		text-overflow: inherit;
		color: #333333;
		font-size: 0.8rem;
		letter-spacing: 2px;
	}
}

.roomsblist {
	padding: 0 0 0 0;
	box-sizing: border-box;
	border: 1px solid #ccc;
	border-radius: 2px;
	background-color: #fff;

	.listtitle {
		width: 100%;
		background-color: #eff0f0;
		color: #333;
		padding: 0.8rem;
		font-size: 1rem;
		font-weight: 700;

		.btns {
			color: #fff;
			background-color: #028ecf;
			padding: 5px 10px;
			border-radius: 6px;
			cursor: pointer;
		}
	}

	.listsb {
		box-sizing: border-box;

		li {
			display: flex;
			align-items: center;
			padding: 1rem 1rem;
			border-bottom: 1px solid #ccc;
			box-sizing: border-box;
			justify-content: space-between;

			button {
				// background-color: rgb(255, 131, 0);
				padding: 0.6rem 0.8rem;
				color: #fff;
				font-size: 0.8rem;
				border-radius: 8px;
			}

			.listsbtitle {
				display: flex;
				align-items: center;
				width: 60%;
				height: 10vh;

				img {
					width: 10%;
					height: 100%;
					border-radius: 1rem;
					margin-right: 1rem;
				}

				// margin-bottom: 1rem;
				p:first-child {
					color: #333;
					font-size: 0.8rem;
					font-weight: 700;
					margin-bottom: 1rem;
				}

				p:last-child {
					color: rgb(165, 172, 179);
					font-size: 0.8rem;
				}
			}
		}
	}
}

.weekend {
	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
	/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #fe8930;
		border-color: #fe8930;
		// padding: 1rem 0;
	}

	/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
		color: #333;
	}
}

.roomlock {
	padding: 1rem 0;
}

.lables {
	font-size: 1rem;
	margin-bottom: 0.4rem;
}

/deep/ .el-tag {
	margin-right: 1rem;
}
</style>

<template>
	<div>
		<titles :titlename="name == '实训室' ? '实训室详情 ' : '设备详情'" titlecontent="设备管理注释" :mbx="paths"></titles>
		<div class="xqlist col-xs-12 col-sm-12 col-md-12 col-lg-10" v-if="name == '实训室'">
			<div class="xqtitlelb col-xs-12 col-sm-12 col-md-6 col-lg-6 hidden-xs-only">
				<el-carousel :interval="4000">
					<el-carousel-item v-if="tadins == 1" v-for="(item, index) in 1" :key="index">
						<img style="border-radius: 1rem; width: 100%;height: 100%;" src="../../images/trainroom1.png" alt="默认图片" srcset="" />
					</el-carousel-item>
					<el-carousel-item v-if="tadins == 0" v-for="(item, index) in tainglist" :key="index">
						<img style="border-radius: 1rem; width: 100%;height: 100%;" :src="item.sx_tp_imgPath" alt="后台拿" srcset="" />
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="xqtitlecontent col-xs-12 col-sm-12 col-md-6 col-lg-6">
				<ul>
					<li>
						<p class="contenttitile">{{ trains.tr_name }}</p>
					</li>
					<li>
						<p class="contenttag">
							<el-tag size="small" effect="dark" v-for="(item, index) in trains.taglist" :key="index">{{ item }}</el-tag>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>实训室地址：</span>
							<span>{{ trains.tr_address }}</span>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>实训室责任人：</span>
							<span>{{ trains.tr_maintenancer }}</span>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>责任人电话：</span>
							<span>{{ trains.tr_mobile }}</span>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>实训室状态：</span>
							<span class="mordel" v-if="trains.tp_status">正常开放</span>
							<span class="mordel coloses" v-else>关闭中</span>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>视频监控：</span>
							<span class="mordel spjkmop" v-if="trains.tr_isOpen">
								<i class="el-icon-video-camera" style="color: #fff;font-size: 1rem;margin-right: 4px;"></i>
								摄像头
							</span>
							<span class="mordel nonlo" v-else>未启用</span>
						</p>
					</li>
					<li>
						<div class="testsm">&nbsp;&nbsp;&nbsp;&nbsp;{{ trains.tr_introduction }}</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="xqlist col-xs-12 col-sm-12 col-md-12 col-lg-10" v-if="name == '实训设备'">
			<div class="xqtitlelb col-xs-12 col-sm-12 col-md-6 col-lg-6">
				<el-carousel :autoplay="false" :loop="false">
					<el-carousel-item v-if="tadins == 1" v-for="(item, index) in 4" :key="index">
						<img style="width: 100%;height: 100%;" src="../../images/traindefut.jpg" alt="这是默认的" srcset="" />
					</el-carousel-item>
					<el-carousel-item v-if="tadins == 0" v-for="(item, index) in trainsbobjlistimg" :key="index">
						<img style="width: 100%;height: 100%;" :src="item" alt="这是后台的" srcset="" />
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="xqtitlecontent col-xs-12 col-sm-12 col-md-6 col-lg-6">
				<ul>
					<li>
						<p class="contenttitile">{{ trainsbobj.te_deviceName }}</p>
					</li>
					<li>
						<p class="contenttag">
							<el-tag size="small" effect="dark" v-for="(item, index) in trainsbobj.te_tag" :key="index">{{ item }}</el-tag>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>设备地址：</span>
							<span>{{ trainsbobj.tr_address ?? '' }}</span>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>设备责任人：</span>
							<span>{{ trainsbobj.te_maintenancer ?? '' }}</span>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>设备ip地址：</span>
							<span>{{ trainsbobj.te_deviceIp ?? '' }}</span>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>设备Mac地址：</span>
							<span>{{ trainsbobj.te_deviceMac ?? '' }}</span>
						</p>
					</li>
					<li class="contentlable">
						<p>
							<span>设备状态：</span>
							<span class="mordel" v-if="trainsbobj.te_deviceState == 1">正常使用</span>
							<span class="mordel coloses" v-if="trainsbobj.te_deviceState == 0">维护</span>
							<span class="mordel coloses" v-if="trainsbobj.te_deviceState == -1">维修检修</span>
							<span class="mordel" v-if="trainsbobj.te_deviceState == -2">空闲</span>
						</p>
					</li>
					<li>
						<div class="testsm">&nbsp;&nbsp;&nbsp;&nbsp;{{ trainsbobj.te_deviceIntroduction ?? '' }}</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="roomstabs">
			<ul class="roomchoes">
				<li style="cursor: pointer;" @click="tabsnum = 1" :class="{ tabsclass: tabsnum == 1 }">
					<span slot="label">
						<i class="el-icon-s-unfold"></i>
						编辑设置
					</span>
				</li>
				<li style="cursor: pointer;" @click="tabsnum = 2" :class="{ tabsclass: tabsnum == 2 }" v-if="name == '实训设备'">
					<!-- <span v-if="name=='实训室'">
						<span slot="label">
							<i class="el-icon-s-order"></i>
							实训室简介
						</span>

					</span> -->
					<span v-if="name == '实训设备'" :class="{ tabsclass: tabsnum == 3 }">
						<i class="el-icon-s-unfold"></i>
						查看生成预约数据
					</span>
				</li>
				<li style="cursor: pointer;" v-if="name == '实训室'" @click="tabsnum = 3" :class="{ tabsclass: tabsnum == 3 }">
					<span slot="label">
						<i class="el-icon-s-grid"></i>
						实训设备
					</span>
				</li>

				<li
					style="cursor: pointer;"
					v-if="name == '实训设备'"
					@click="
						tabsnum = 3;
						getsjlist();
					"
					:class="{ tabsclass: tabsnum == 3 }"
				>
					<span>
						<i class="el-icon-s-unfold"></i>
						配置设备理论考核
					</span>
				</li>
			</ul>
			<div v-if="tabsnum == 1" class="tabslist1">
				<p class="titlwrooms" v-if="name == '实训室'">基础信息</p>
				<!-- <span class="titlwrooms" v-if="name=='实训设备'">修改设备信息</span> -->
				<form v-if="name == '实训设备'">
					<el-row :gutter="20">
						<el-col :span="12">
							<p class="lables">设备名称</p>
							<input v-model="trainsbsobj.te_deviceName" class="form-control form-control-lg" type="text" placeholder="设备名称" />
						</el-col>

						<el-col :span="12">
							<p class="lables">设备编号</p>
							<input v-model="trainsbsobj.te_deviceNumber" class="form-control form-control-lg" type="text" placeholder="设备编号" />
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<p class="lables">设备ip地址</p>
							<input
								@input="ipchanges()"
								v-model="trainsbsobj.te_deviceIp"
								maxlength="17"
								class="form-control form-control-lg"
								type="text"
								placeholder="设备ip地址"
								:style="{ 'border-color': isipshow ? 'red' : '', 'box-shadow': isipshow ? '1px 1px 1px red' : '' }"
							/>
							<span v-if="isipshow" style="color: red;margin-left: 0.4rem;font-size: 0.6vw;">请输入正确的ip地址</span>
						</el-col>
						<el-col :span="12">
							<p class="lables">设备Mac地址</p>
							<input
								@input="macchanges()"
								v-model="trainsbsobj.te_deviceMac"
								maxlength="17"
								class="form-control form-control-lg"
								type="text"
								placeholder="设备Mac地址"
								:style="{ 'border-color': ismacshow ? 'red' : '', 'box-shadow': ismacshow ? '1px 1px 1px red' : '' }"
							/>
							<span v-if="ismacshow" style="color: red;margin-left: 0.4rem;font-size: 0.6vw;">请输入正确的mac地址</span>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<p class="lables">所属实训室</p>
							<select v-model="trainsbsobj.sx_tr_guid" class="form-control" id="exampleFormControlSelect1">
								<option value="">-- 请选择实训室 --</option>
								<option v-for="(item, index) in trainsnaameslist" :key="index" :value="item.sx_tr_guid">{{ item.tr_name }}</option>
							</select>
						</el-col>
						<el-col :span="12">
							<p class="lables">设备管理员</p>
							<input v-model="trainsbsobj.te_maintenancer" class="form-control form-control-lg" type="text" placeholder="设备管理员" />
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<p class="lables">实训设备状态</p>
							<div class="ridio">
								<el-radio-group v-model="radio">
									<el-radio label="1">正常（启用）</el-radio>
									<el-radio label="0">离线</el-radio>
									<el-radio label="-1">维护/检修</el-radio>
									<el-radio label="-2">空闲</el-radio>
								</el-radio-group>
							</div>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<p class="lables">标签Tag</p>
							<div style="display: flex;align-items: center;">
								<el-tag v-for="tag in dynamicTags" :key="tag" closable :disable-transitions="false" @close="handleClose(tag)">{{ tag }}</el-tag>
								<div style="width: 10vw;">
									<el-input
										class="input-new-tag"
										v-if="inputVisible"
										v-model="inputValue"
										ref="saveTagInput"
										size="small"
										@keyup.enter.native="handleInputConfirm"
										@blur="handleInputConfirm"
									></el-input>
									<button v-else size="small" style="color: red;font-size: 0.8rem;" class="button-new-tag" @click="showInput">点击新增</button>
								</div>
							</div>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<p class="titlwrooms" style="margin-left:1rem">设备简介</p>
						<el-col :span="24"><textarea v-model="trainsbsobj.te_deviceIntroduction" class="form-control" id="exampleFormControlTextarea1" rows="8"></textarea></el-col>
					</el-row>
				</form>

				<form v-if="name == '实训室'">
					<el-row :gutter="20">
						<el-col :span="16">
							<p class="lables">实训室名称</p>
							<input v-model="trainbobjs.tr_name" class="form-control form-control-lg" type="text" placeholder="实训室名称" />
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<p class="lables">请选择实训室管理员</p>
							<div style="width: 100%;height: 100%;">
								<el-select v-model="isshowmanid" placeholder="请选择实训室管理员" multiple @change="changeusers">
									<el-option v-for="item in ternerlist" :key="item.ui_guid" :label="item.ui_realName" :value="item.ui_guid">
										<span style="float: left">{{ item.ui_realName }}</span>
										<span style="float: right; color: #8492a6; font-size: 13px">{{ item.ui_mobile }}</span>
									</el-option>
								</el-select>
							</div>
							<!-- <input v-model="trainbobjs.tr_maintenancer" class="form-control form-control-lg" type="text"
								placeholder="实训室负责人"> -->
						</el-col>
						<el-col :span="12">
							<p class="lables">负责人电话</p>
							<input v-model="trainbobjs.tr_mobile" class="form-control form-control-lg" type="text" placeholder="负责人电话" />
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p class="lables">实训室地址</p>
							<input v-model="trainbobjs.tr_address" class="form-control form-control-lg" type="text" placeholder="实训室地址" />
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p class="lables">视频监控地址</p>
							<input class="form-control form-control-lg" type="text" placeholder="视频监控地址" />
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<p class="lables">实训室简介</p>
							<textarea
								v-model="trainbobjs.tr_introduction"
								class="form-control form-control-lg"
								style="height: 200px;"
								type="text"
								placeholder="实训室简介"
							></textarea>
						</el-col>
					</el-row>
				</form>
				<div class="roomszt" v-if="name == '实训室'">
					<p class="titlwrooms">实训室状态</p>
					<el-radio v-model="radio" label="1" text-color="#000">开启</el-radio>
					<el-radio v-model="radio" label="2" :fill="'#FE8930'">关闭</el-radio>
					<el-row style="margin-top: 1rem;" :gutter="20" v-if="name == '实训室'">
						<el-col :span="12">
							<p class="lables" style="margin-bottom: 0.4rem;">标签Tag</p>
							<div style="display: flex;align-items: center;">
								<el-tag v-for="tag in dynamicTags" :key="tag" closable :disable-transitions="false" @close="handleClose(tag)">{{ tag }}</el-tag>
								<div style="width: 10vw;">
									<el-input
										class="input-new-tag"
										v-if="inputVisible"
										v-model="inputValue"
										ref="saveTagInput"
										size="small"
										@keyup.enter.native="handleInputConfirm"
										@blur="handleInputConfirm"
									></el-input>
									<button v-else size="small" style="color: red;font-size: 0.8rem;" class="button-new-tag" @click="showInput">点击新增</button>
								</div>
							</div>
						</el-col>
					</el-row>
					<form v-if="name == '实训室'" style="padding: 2rem 0;border-top: 1px solid #ccc;margin-top: 1rem;border-bottom: 1px solid #ccc;" class="weekend">
						<p class="titlwrooms">实训室相关设置</p>

						<!-- <el-row :gutter="20">
							<el-col :span="12">
								<p class="lables">实训室最大预约人数</p>
								<input v-model="trainsbsobj.ap_reservedNum" class="form-control form-control-lg" type="text" placeholder="实训人数" />
							</el-col>
						</el-row> -->
						<el-row :gutter="20">
							<p class="lables" style="padding-left: 10px;">
								实训室当天可预约时间
								<!-- <el-button type="primary" title="添加时间段"></el-button> -->
							</p>

							<!-- 我有一个时间数组，
							我要判断一下选择时间段的区间，
							 假如我现在选了9 ~ 10点钟
							 那么我9点到10点的都禁用
							 -->
							<div style="padding: 0 40px;">
								<el-table :data="tableData" style="width: 100%;" :style="istabls ? 'border:1px solid red;' : ''">
									<el-table-column label="开始时间">
										<template slot-scope="scope">
											<el-select clearable v-model="scope.row.s_time" @change="changestime(scope.row, scope)" placeholder="请选择开始时间">
												<el-option v-for="item in timerlists" :key="item.value" :value="item.value"></el-option>
											</el-select>
										</template>
									</el-table-column>

									<el-table-column label="结束时间">
										<template slot-scope="scope">
											<el-select clearable v-model="scope.row.e_time" @change="changeetime(scope.row, scope)" placeholder="请选择结束时间">
												<el-option v-for="item in timerlists" :key="item.value" :value="item.value" :disabled="item.disabled"></el-option>
											</el-select>
										</template>
									</el-table-column>

									<el-table-column label="请选择人数">
										<template slot-scope="scope">
											<div style="width: 200px;display: flex;align-items: center;justify-content: space-between;">
												<input
													type="number"
													style="width: 60px;border: 1px solid #ccc;padding: 5px;"
													v-model="scope.row.number"
													oninput="if(value>60)value=30;if(value<2)value=1"
												/>
												<div @click="delects(scope)" style="margin-left: 40px;color: red;text-decoration: underline;cursor: pointer;">删除</div>
											</div>
										</template>
									</el-table-column>
								</el-table>
								<div class="addtable" style="width: 100%;display: flex;justify-content: center;margin: 10px 0;" v-if="tableData.length < 8">
									<el-button style="width: 200px;" @click="addtable" size="mini" round type="primary" icon="el-icon-circle-plus"></el-button>
								</div>
							</div>

							<!-- <el-col :span="12">
								<el-time-select
									v-model="trainsbsobj.starttimer"
									:picker-options="{
										start: '8:00',
										step: '1:00',
										end: '23:00'
									}"
									placeholder="当天实训开始时间"
									style="width: 100%;"
								></el-time-select>
							</el-col>
							<el-col :span="12">
								<el-time-select
									v-model="trainsbsobj.endtimer"
									:picker-options="{
										start: '8:00',
										step: '1:00',
										end: '23:00'
									}"
									placeholder="当天实训结束时间"
									style="width: 100%;"
								></el-time-select>
							</el-col> -->
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-checkbox-group v-model="checkList">
									<el-checkbox label="1">星期一</el-checkbox>
									<el-checkbox label="2">星期二</el-checkbox>
									<el-checkbox label="3">星期三</el-checkbox>
									<el-checkbox label="4">星期四</el-checkbox>
									<el-checkbox label="5">星期五</el-checkbox>
									<el-checkbox label="6">星期六</el-checkbox>
									<el-checkbox label="7">星期日</el-checkbox>
								</el-checkbox-group>
							</el-col>
							<el-col :span="12">
								<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2" style="width: auto;">
									<input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="ispassds" />
									<span style="margin-left: 10px;">是否开启预约自动审核</span>
								</p>
							</el-col>
						</el-row>
					</form>
				</div>

				<form v-if="name == '实训设备'" style="padding: 2rem 0;border-top: 1px solid #ccc;margin-top: 1rem;border-bottom: 1px solid #ccc;" class="weekend">
					<p class="titlwrooms">实训设备相关设置</p>

					<!-- <el-row :gutter="20">
						<p class="lables" style="margin-left: 10px;">实训设备最大预约人数</p>
						<el-col :span="12"><input v-model="trainsbsobj.ap_reservedNum" class="form-control form-control-lg" type="text" placeholder="实训人数" /></el-col>
					</el-row> -->
					<el-row :gutter="20">
						<p class="lables" style="margin-left: 10px;">实训设备当天可预约时间</p>
						<div style="padding: 0 40px;">
							<el-table :data="tableData" style="width: 100%" :style="istabls ? 'border:1px solid red;' : ''">
								<el-table-column label="开始时间">
									<template slot-scope="scope">
										<el-select clearable v-model="scope.row.s_time" @change="changestime(scope.row, scope)" placeholder="请选择开始时间">
											<el-option v-for="item in timerlists" :key="item.value" :value="item.value"></el-option>
										</el-select>
									</template>
								</el-table-column>

								<el-table-column label="结束时间">
									<template slot-scope="scope">
										<el-select clearable v-model="scope.row.e_time" @change="changeetime(scope.row, scope)" placeholder="请选择结束时间">
											<el-option v-for="item in timerlists" :key="item.value" :value="item.value" :disabled="item.disabled"></el-option>
										</el-select>
									</template>
								</el-table-column>

								<el-table-column label="请选择人数">
									<template slot-scope="scope">
										<div style="width: 200px;display: flex;align-items: center;justify-content: space-between;">
											<input
												type="number"
												style="width: 60px;border: 1px solid #ccc;padding: 5px;"
												v-model="scope.row.number"
												oninput="if(value>60)value=30;if(value<2)value=1"
											/>
											<div @click="delects(scope)" style="margin-left: 40px;color: red;text-decoration: underline;cursor: pointer;">删除</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="addtable" style="width: 100%;display: flex;justify-content: center;margin: 10px 0;" v-if="tableData.length < 8">
								<el-button style="width: 200px;" @click="addtable" size="mini" round type="primary" icon="el-icon-circle-plus"></el-button>
							</div>
						</div>
						<!-- <el-col :span="12"><input v-model="trainsbsobj.starttimer" class="form-control form-control-lg" type="text" placeholder="当天实训开始时间" /></el-col>
						<el-col :span="12"><input v-model="trainsbsobj.endtimer" class="form-control form-control-lg" type="text" placeholder="当天实训结束时间" /></el-col> -->
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-checkbox-group v-model="checkList">
								<el-checkbox label="1">星期一</el-checkbox>
								<el-checkbox label="2">星期二</el-checkbox>
								<el-checkbox label="3">星期三</el-checkbox>
								<el-checkbox label="4">星期四</el-checkbox>
								<el-checkbox label="5">星期五</el-checkbox>
								<el-checkbox label="6">星期六</el-checkbox>
								<el-checkbox label="7">星期日</el-checkbox>
							</el-checkbox-group>
						</el-col>
						<el-col :span="12">
							<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2" style="width: auto;">
								<input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="ispassds" />
								<span style="margin-left: 10px;">是否开启预约自动审核</span>
							</p>
						</el-col>
					</el-row>
				</form>
				<div v-if="name == '实训室'" class="roomsupload">
					<!-- style="padding: 1rem 0;" -->
					<p class="titlwrooms">上传实训室照片</p>

					<el-upload
						show-file-list
						action="#"
						list-type="picture-card"
						:file-list="imglist"
						:limit="20"
						:on-change="changeinms"
						:on-success="successtrains"
						multiple
						:auto-upload="false"
						ref="pictureUpload"
					>
						<i slot="default" class="el-icon-plus"></i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					<el-dialog
						custom-class="imgdialog"
						title="修改图片"
						:before-close="handleCloseimg"
						close-on-press-escape
						close-on-click-modal
						destroy-on-close
						center
						:visible.sync="dialogVisibleimg"
					>
						<div style="display: flex;align-items: center;justify-content: center;">
							<div style="display: flex;align-items: center;flex-direction: column;">
								<div style="width: 30rem;height: 30rem;">
									<vueCropper
										ref="cropper"
										:img="dialogImageUrl"
										:outputSize="option.outputSize"
										:outputType="option.outputType"
										:info="option.info"
										:full="option.full"
										:canMove="option.canMove"
										:canMoveBox="option.canMoveBox"
										:original="option.original"
										:autoCrop="option.autoCrop"
										:autoCropWidth="option.autoCropWidth"
										:autoCropHeight="option.autoCropHeight"
										:fixedBox="option.fixedBox"
										@realTime="realTime"
									></vueCropper>
								</div>
							</div>

							<div
								style="width: 30rem;
									display: flex;
									align-items: center;
									margin-left: 1rem;"
							>
								<img :src="corappurl" alt="" style="width: 25rem;height: 15rem;border: 1px solid #ccc;margin-right: 1rem;" />
							</div>
						</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="dialogVisibleimg = false">取 消</el-button>
							<el-button type="primary" @click="changeheadimg()">确 定</el-button>
						</span>
					</el-dialog>

					<div class="save" style="display: flex;cursor: pointer;">
						<p @click="savetrains()" class="savenone" v-preventReClick>保存</p>
						<!-- 	<p v-if="name=='实训室'" @click="<strong>deletrains</strong>()" class="savenone" style="background-color: #e60000;">删除
								</p> -->
					</div>

					<!-- <p class="clickrooms" style="cursor: pointer;" @click="clickrooms()">点击上传</p>
					<form v-show="false">
						<div class="form-group">
							<input @change="handleChange" ref="filrx" accept=".png,.jpg" type="file"
								class="form-control-file" id="exampleFormControlFile1">
						</div>
					</form>
					<swiper name="实训室" :imglist="tainglist" :swiperOptions="swiperOption"></swiper> -->
				</div>
				<div v-if="name == '实训设备'" class="roomsupload" style="padding: 1rem 0;">
					<p class="titlwrooms">上传实训设备照片</p>
					<p class="clickrooms" style="cursor: pointer;" @click="clickroomsa()">点击上传</p>
					<form v-show="false">
						<div class="form-group">
							<input @change="handleChangetsb" ref="filrxs" accept=".png,.jpg" type="file" class="form-control-file" id="exampleFormControlFile1" />
						</div>
					</form>
					<el-dialog
						custom-class="imgdialog"
						title="修改图片"
						:before-close="handleCloseimg"
						close-on-press-escape
						close-on-click-modal
						destroy-on-close
						center
						:visible.sync="dialogVisibletrainsimg"
					>
						<div style="display: flex;align-items: center;justify-content: center;">
							<div style="display: flex;align-items: center;flex-direction: column;">
								<div style="width: 30rem;height: 30rem;">
									<vueCropper
										ref="trainscropper"
										:img="trainsimg"
										:outputSize="option.outputSize"
										:outputType="option.outputType"
										:info="option.info"
										:full="option.full"
										:canMove="option.canMove"
										:canMoveBox="option.canMoveBox"
										:original="option.original"
										:autoCrop="option.autoCrop"
										:autoCropWidth="option.autoCropWidth"
										:autoCropHeight="option.autoCropHeight"
										:fixedBox="option.fixedBox"
										@realTime="trainsrealTime"
									></vueCropper>
								</div>
							</div>

							<div
								style="width: 320px;
									height: 245px;
									display: flex;
									align-items: center;
									margin-left: 1rem;"
							>
								<img :src="corappurl" alt="" style="width: 25rem;height: 15rem;border: 1px solid #ccc;margin-right: 1rem;" />
							</div>
						</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="dialogVisibletrainsimg = false">取 消</el-button>
							<el-button type="primary" @click="changeheadtrains()">确 定</el-button>
						</span>
					</el-dialog>

					<img v-if="tadins == 0" style="width: 20%;margin-left: 4%;margin-top: 1rem;" :src="sbimgs" alt="这是一张图片,确确实实是有图片的!只不过没显示" />

					<div class="save" style="display: flex;margin-top: 1rem;">
						<p @click="savetrains()" class="savenone" v-preventReClick>保存</p>
						<!-- 	<p v-if="name=='实训室'" @click="<strong>deletrains</strong>()" class="savenone" style="background-color: #e60000;">删除
								</p> -->
					</div>
				</div>
			</div>
		</div>

		<div v-if="tabsnum == 2" class="tabslist1">
			<div class="roomjj" v-if="name == '实训室'">{{ trains.tr_introduction }}</div>
			<div class="roomlock" v-if="name == '实训设备'"><FullCalendar name="实训设备" :oknumlist="oknumlist"></FullCalendar></div>
		</div>

		<div v-if="tabsnum == 3" class="tabslist1">
			<div class="roomsblist">
				<p class="listtitle" v-if="name == '实训室'">实训设备列表</p>
				<p class="listtitle" v-if="name == '实训设备'">
					<span>添加试题练习试卷：</span>
					<span
						@click="
							drawer = true;
							getsjlist();
						"
						class="btns"
					>
						点击获取
					</span>
				</p>
				<ul class="listsb" v-if="name == '实训室'">
					<el-empty v-if="trainsblist.length == 0" description="当前实训设备为空"></el-empty>
					<li v-for="(item, index) in trainsblist" :key="index">
						<div class="listsbtitle">
							<img v-if="item.te_image != ''" :src="item.te_image" alt="" />
							<img v-else src="../../images/sbheader.svg" alt="" />
							<div style="width: 100%;">
								<p>{{ item.te_deviceName }}</p>
								<p>{{ item.te_deviceIntroduction }}</p>
							</div>
						</div>
						<button type="button" style="background-color: #FF8300;" v-if="item.te_deviceState == -1 && item.te_deviceIp">{{ item.te_deviceIp }}</button>
						<button type="button" style="background-color: #0ACF97;" v-if="item.te_deviceState == 1 && item.te_deviceIp">{{ item.te_deviceIp }}</button>
						<button type="button" style="background-color: #F2125E;" v-if="item.te_deviceState == 0 && item.te_deviceIp">{{ item.te_deviceIp }}</button>
						<button type="button" style="background-color: #FF8300;" v-if="item.te_deviceState == -2 && item.te_deviceIp">{{ item.te_deviceIp }}</button>
					</li>
				</ul>

				<ul class="listsb" v-if="name == '实训设备'">
					<div style="width: 100%;box-sizing: border-box;padding: 32px;">
						<el-table :data="khstableData" border style="width: 100%">
							<el-table-column prop="SPA_PaperTitle" label="试卷名称"></el-table-column>
							<el-table-column prop="SPA_Duration" label="总分"></el-table-column>
							<el-table-column label="操作" width="100">
								<template slot-scope="scope">
									<div class="spalist"><p @click="deltespas(scope.row)" class="spabtn">取消绑定</p></div>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</ul>
			</div>
		</div>

		<el-drawer :visible.sync="drawer" :with-header="false">
			<div class="titlesdrawer">选择试卷</div>
			<div class="tablelistchioce">
				<div class="ismulitlist">
					<p v-for="(item, idx) in chiocemultipleSelection" :key="idx">{{ item.SPA_PaperTitle }}</p>
				</div>
				<button @click="hanlderchioce" type="button">选择试卷</button>
			</div>
			<div class="chiocetables" style="padding: 0 32px 32px;">
				<el-table ref="multipleTable" :data="chiocetableData" @selection-change="chiocetaSelectionChange" header-row-class-name="tablestitle" border style="width: 100%;">
					<el-table-column :resizable="false" type="selection" width="55"></el-table-column>
					<el-table-column :resizable="false" label="试卷名称" prop="SPA_PaperTitle">
						<template slot-scope="scope">
							<p>{{ scope.row.SPA_PaperTitle }}</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-drawer>
	</div>
</template>

<!-- <li v-for="(item, index) in trainsbcharen" :key="index">
	<div class="listsbtitle">
		<img v-if="item.cte_status == 1" src="../../images/childerzt.svg" alt="" />
		<img v-if="item.cte_status == -2 || item.cte_status == -1" src="../../images/yzm1.svg" alt="" />
		<img v-if="item.cte_status == 0" src="../../images/yzm2.svg" alt="" />
		<div style="width: 100%;">
			<p>{{ item.cte_childName }}</p>
			<p>{{ item.cte_remark }}</p>
		</div>
	</div>
	<button v-if="item.cte_status == 1" type="button" style="background-color: #2ECC71;">在线</button>
	<button v-if="item.cte_status == -2" type="button" style="background-color: #95A5A6;">离线</button>
	<button v-if="item.cte_status == -1" type="button" style="background-color: #95A5A6;">离线</button>
	<button v-if="item.cte_status == 0" type="button" style="background-color: #F1C40F;">维护</button>
</li> -->

<script>
import titles from '@/components/title/title.vue';
import swiper from '@/components/swiper.vue';
import FullCalendar from '@/pageme/Calendar.vue';
import 'element-ui/lib/theme-chalk/display.css';
import {
	getTrainSingle,
	getTrainEquipmentList,
	getTrainEquipmentSingle,
	getAddTrain,
	getdgPageTrainDelete,
	getUpdatetrainsb,
	GetTrainEquipmentChildList,
	InsertsbOrEditTrainingSet,
	GetscTrainingSetSingle,
	TrainUploadTrainImages,
	TrainEditTrainImages,
	TrainDeleteTrainPic,
	GetbfyTrainEquipmentLists,
	getbfyGetTrainList,
	TrainEquipmentUploadImages,
	InsertOrEditTrainingroomSet,
	GetTrainingroomSetSingle,
	GetAppointmentroomCount,
	getPageTrainEquipmentList
} from '@/request/api/trainroom/trainroom.js';

import { GetUserSelect } from '@/request/api/mange/mange.js';
import { getBase64, setbaseurl } from '@/utils/utils.js';
import { GetPaperlistApi, PaperOrAbility, DeletePaperorability } from '@/request/api/homesview/yunhomes/yunhom.js';
import { VueCropper } from 'vue-cropper';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			chiocetablepaper: [],
			// 抽屉
			drawer: false,
			chiocemultipleSelection: [],
			chiocetableData: [],
			chiocetapageindex: 1,
			// 修改责任人
			ternerlist: [],
			isshowmanid: [],
			//
			ispassds: false,
			// 上传图片
			imggnaes: '',
			dialogVisibleimg: false,
			dialogImageUrl: '',
			imglist: [],
			baseurl: '',
			disabled: false,
			ismacshow: false,
			isipshow: false,
			// tag组件
			dynamicTags: [],
			inputVisible: false,
			inputValue: '',
			//tab栏
			tabsnum: 1,
			// 多选
			checkList: ['1', '2', '3', '4', '5'],
			// 照片枪对象
			swiperOption: {
				loop: true,
				slidesPerView: 3,
				freeMode: true,
				spaceBetween: 10,
				grid: {
					fill: 'column',
					rows: 2
				}
				// // 显示分页
				// pagination: {
				// 	el: ".swiper-pagination",
				// 	clickable: true, //允许分页点击跳转
				// 	type: 'progressbar'
				// },
				// // 设置点击箭头
				// navigation: {
				// 	nextEl: ".swiper-button-next",
				// 	prevEl: ".swiper-button-prev"
				// },
			},

			// 上传
			fileList: [],
			// 单选按钮状态
			radio: '1',
			// 标题组件
			paths: [
				{
					path: '/allmanage/trainingmange',
					name: ''
				},
				{
					path: '/allmanage/roomsxq',
					name: ''
				}
			],
			// 判断实训室还是实训设备
			name: '',
			id: 0,
			scoolid: '',
			// 实训室列表
			trains: {},
			tadins: null,
			// 实训设备列表
			trainsblist: [],
			sxteguid: '',
			trainbobjs: {},
			// 实训设备
			trainsbobj: {},
			trainsbsobj: {
				ap_reservedNum: 1,
				starttimer: '8:00',
				endtimer: '22:30',
				sx_ts_guid: ''
			},
			// 列表图片
			tainglist: [],
			// 所属实训室
			trainsnaames: '',
			// 子设备列表
			trainsbcharen: [],
			// 实训室不分页
			trainsnaameslist: [],
			// 可预约日期列表
			oknumlist: [],
			// 图片上传
			filexs: '',
			tainglistg: [],
			sbimgs: '',
			fileimgsb: {},
			tainglistgs: [],
			trainsbobjlistimg: [],
			// 学校id
			siguid: '',
			// 图片截取
			option: {
				img: '', // 裁剪图片的地址
				info: true, // 裁剪框的大小信息
				outputSize: 0.8, // 裁剪生成图片的质量
				outputType: 'jpeg', // 裁剪生成图片的格式
				canScale: false, // 图片是否允许滚轮缩放
				autoCrop: true, // 是否默认生成截图框
				autoCropWidth: 320, // 默认生成截图框宽度
				autoCropHeight: 245, // 默认生成截图框高度
				fixedBox: true, // 固定截图框大小 不允许改变
				fixed: false, // 是否开启截图框宽高固定比例
				fixedNumber: [1, 0], // 截图框的宽高比例
				full: true, // 是否输出原图比例的截图
				canMoveBox: true, // 截图框能否拖动
				original: true, // 上传图片按照原始比例渲染
				centerBox: true, // 截图框是否被限制在图片里面
				infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
			},
			corappurl: '',
			newfilenow: '',
			dialogImageObj: {},
			imgslist: [],
			dialogVisibletrainsimg: false,
			trainsimg: '',
			trainsobjimgs: {},
			// 获取tablue
			tableData: [],
			columnList: [
				{
					prop: 'name',
					label: '姓名',
					align: 'center',
					slotKey: 'name',
					slotHeaderKey: 'nameHeader'
				}
			],
			timerlists: [],
			// 判断错误
			istabls: false,
			khstableData: []
		};
	},
	created() {
		AppOptions.appEmpty = false;
		this.sertimerlist();
		// console.log(this.swiperOption)
		this.name = this.$route.query.name;
		this.id = this.$route.query.id;
		this.scoolid = this.$route.query.schoolid;
		this.sxteguid = this.$route.query.sx_te_guid;
		this.paths[this.paths.length - 2].name = this.name == '实训室' ? '实训室管理 ' : '实训设备管理';
		this.paths[this.paths.length - 2].path = this.name == '实训室' ? '/allmanage/trainingmange' : '/allmanage/trainingmangesb';
		this.paths[0].path = this.name == '实训室' ? '/allmanage/trainingmange' : '/allmanage/trainingmangesb';
		this.paths[this.paths.length - 1].name = this.name == '实训室' ? '实训室详情 ' : '设备详情';
		this.siguid = localStorage.getItem('siguid');
	},
	beforeMount() {
		if (this.name !== '实训设备') {
			this.gettainsinle();
			this.getrainsbs();
			// console.log("实训室")
		} else {
			// console.log("实训设备")
			this.getraineginle();
		}

		this.baseurl = setbaseurl() + '/Train/UploadTrainImages';
	},
	methods: {
		// 取消绑定试卷
		deltespas(val) {
			// console.log(val, '提交');
			let objs = {
				SPA_GUID: val.SPA_GUID,
				sx_te_guid: this.sxteguid
			};

			this.$confirm('此操作将取消绑定试卷, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					DeletePaperorability(objs).then(res => {
						// console.log(res);
						if (res.data.code > 0) {
							this.getsjlist();
						}
					});
				})
				.catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
		},

		// 绑定试卷列表
		hanlderchioce() {
			// console.log('获取绑定试卷', this.chiocemultipleSelection);
			let updatalist = [];
			this.chiocemultipleSelection.forEach(ite => {
				updatalist.push({
					SPA_GUID: ite.SPA_GUID,
					sx_te_guid: this.sxteguid
				});
			});
			PaperOrAbility(updatalist).then(res => {
				// console.log(res, '绑定试卷');
				if (res.data.code > 0) {
					this.chiocemultipleSelection = [];
					this.getsjlist();
					this.drawer = false;
				}
			});
		},

		// 选择试卷表格
		chiocetaSelectionChange(val) {
			this.chiocemultipleSelection = val;
		},
		toggleSelection(rows) {
			this.$nextTick(() => {
				setTimeout(() => {
					if (rows) {
						rows.forEach(row => {
							this.$refs.multipleTable.toggleRowSelection(row);
						});
					} else {
						this.$refs.multipleTable.clearSelection();
					}
				}, 200);
			});
		},
		// 获取试卷列表
		getsjlist() {
			GetPaperlistApi({
				pageIndex: this.chiocetapageindex,
				pageSize: 200,
				sx_te_guid: this.sxteguid
			}).then(res => {
				// console.log('获取试卷列表', res);
				this.chiocetableData = res.data.data.list;
				let chiocetablepaper = [];
				if (this.chiocetableData.length > 0) {
					this.chiocetableData.forEach(ite => {
						if (ite.isPaperorability == 1) {
							chiocetablepaper.push(ite);
						}
					});
				}
				this.chiocetablepaper = chiocetablepaper;
				this.khstableData = chiocetablepaper;
				this.chiocemultipleSelection = chiocetablepaper;
				if (this.$refs.multipleTable) {
					this.toggleSelection(chiocetablepaper);
				}
			});
		},

		// 改变时间判断静止事件
		changestime(row, scol) {
			// console.log(scol,'获取当前对象')
			// 改变开始时间,判断是否有重复时间
			let isstime = this.tableData.filter(ite => row.s_time === ite.s_time);
			let isetime = this.tableData.filter(ite => row.e_time === ite.e_time);
			// console.log(isstime,isetime,'时间列表')
			if (isstime.length > 1 || isetime.length > 1) {
				this.tableData[scol.$index].s_time = '';
				this.$message('当前选择的时间与其他时间发生冲突');
			}
		},
		changeetime(row, scol) {
			// console.log(row,'结束时间')
			let isstime = this.tableData.filter(ite => row.s_time === ite.s_time);
			let isetime = this.tableData.filter(ite => row.e_time === ite.e_time);
			// console.log(isstime,isetime,'时间列表')
			if (isstime.length > 1 || isetime.length > 1) {
				this.tableData[scol.$index].e_time = '';
				this.$message('当前选择的时间与其他时间发生冲突');
				return;
			}
			let etimeindex = this.timerlists.findIndex(value => value.value === row.s_time);
			let stimeindex = this.timerlists.findIndex(value => value.value === row.e_time);
			// console.log(etimeindex,stimeindex); // 输出第一个值为1的索引，即0
			if (etimeindex != -1 && stimeindex != -1) {
				let newtimers = this.timerlists.slice(etimeindex + 1, stimeindex);
				// console.log(newtimers);

				if (newtimers.length == 0) {
					return;
				}
				for (let i = 0; i < this.tableData.length; i++) {
					if (isTimeInArray(this.tableData[i].s_time, newtimers)) {
						this.tableData[scol.$index].e_time = '';
						this.$message('当前选择的时间与其他时间发生冲突');
						console.log('先看开始时间', this.tableData[i].s_time);
						break;
					}

					if (isTimeInArray(this.tableData[i].e_time, newtimers)) {
						this.tableData[scol.$index].e_time = '';
						this.$message('当前选择的时间与其他时间发生冲突');
						console.log('再看结束时间', this.tableData[i].e_time);
						break;
					}
				}
			}

			function isTimeInArray(time, array) {
				for (const item of array) {
					if (item.value === time) {
						return true;
					}
				}
				return false;
			}

			// console.log(newtimers,this.tableData)
		},
		// 删除
		delects(itm) {
			// console.log(itm.row,'删除不')
			this.tableData.splice(itm.$index, 1);
		},

		sertimerlist() {
			let start = 8;
			let end = 23;
			let timeArray = [];

			for (let i = start; i <= end; i++) {
				let hours = i < 10 ? '0' + i : i; // 在小时前面添加0，如果小时小于10
				let minutes = '00'; // 所有时间都设置为00分钟
				timeArray.push({
					value: hours + ':' + minutes,
					disabled: false
				});
			}
			this.timerlists = timeArray;
		},

		// 添加时间列表
		addtable() {
			// console.log('添加时间table',this.tableData)
			let tablenum = this.tableData ? this.tableData.length : 0;
			if (tablenum != 0) {
				tablenum = this.timerlists.findIndex(value => value.value === this.tableData[tablenum - 1].e_time);
			}
			this.tableData.push({
				s_time: this.timerlists[tablenum].value,
				e_time: this.timerlists[tablenum + 1].value,
				number: 8
			});
		},
		// 清空时间选择
		cleardisabled(num, item) {
			let isdisabledlist = this.timerlists.map(ite => {
				if (ite.disabled && ite.value) {
					return ite.value;
				}
			});
		},
		changedisabled(num, item) {
			let timerlists = JSON.parse(JSON.stringify(this.timerlists));

			let startNum = item.s_time != '' ? item.s_time.slice(0, 2) : '';
			let endNum = item.e_time != '' ? item.e_time.slice(0, 2) : '';

			if (num == 0) {
				if (item.e_time != '') {
					if (startNum > endNum) {
					}
				} else {
					timerlists.forEach(ite => {
						if (item.s_time == ite.value) {
							ite.disabled = true;
						} else if (!ite.disabled) {
							ite.disabled = false;
						}
					});
				}
				// console.log(timerlists)
				this.timerlists = timerlists;
			} else if (num == 1) {
				// 获取两个数字之间的绝对差值
				let diff = Math.abs(parseInt(startNum) - parseInt(endNum));

				// 获取差值的整数部分（不包括小数部分）
				let numDigits = Math.floor(diff);

				// 创建一个包含这些数字的数组
				let digitsArray = [];
				for (let i = 0; i < numDigits; i++) {
					digitsArray.push(parseInt(startNum) + parseInt(i));
				}
				// console.log(digitsArray, diff, numDigits);
				timerlists.forEach(ite => {
					if (item.e_time == ite.value) {
						ite.disabled = true;
					} else if (!ite.disabled) {
						ite.disabled = false;
					}
				});

				if (digitsArray.length > 0) {
					for (let i = 0; i < digitsArray.length; i++) {
						let nowtime = digitsArray[i] < 10 ? '0' + digitsArray[i] : digitsArray[i];
						timerlists.forEach(ite => {
							if (ite.value.slice(0, 2) == nowtime) {
								ite.disabled = true;
							}
						});
					}
				}

				// console.log(timerlists,digitsArray)
				this.timerlists = timerlists;
			}
		},

		// 放回
		handleCloseimg(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		savetrainset() {
			let data = {
				sx_tr_guid: this.trainbobjs.sx_tr_guid,
				sx_ts_guid: this.trainsbsobj.sx_ts_guid,
				sx_ts_number: this.trainsbsobj.ap_reservedNum,
				sx_ts_startTime: this.trainsbsobj.starttimer,
				sx_ts_endTime: this.trainsbsobj.endtimer,
				sx_ts_trainCycle: this.checkList.join(','),
				sx_tr_AutoApprove: this.ispassds,
				sxTimeconfiguration: this.tableData
			};

			InsertOrEditTrainingroomSet(data).then(res => {
				if (res.data.code == 1) {
					// console.log("保存设置")
					// console.log(res)
					// this.$message({
					// 	message: '恭喜你，' + res.data.msg,
					// 	type: 'success'
					// });
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		// 获取用户
		GetuserSelects() {
			let datas = {
				pageIndex: 1,
				pageSize: 100,
				ui_userName: '',
				si_guid: this.trainbobjs.si_guid,
				ut_guid: ''
			};
			// console.log(this.isshowman)

			GetUserSelect(datas).then(res => {
				// console.log(res.data.data, "获取学生222")
				this.ternerlist = res.data.data.list;
				if (this.ternerlist.length == 0) {
					this.isshowmanid = '';
				}
			});
		},
		changeusers(e) {
			let ternerobjmobile = [];
			let ternerobjuiguid = [];
			let maintenancerlist = [];
			e.forEach(itme => {
				this.ternerlist.forEach(it => {
					if (itme == it.ui_guid) {
						ternerobjmobile.push(it.ui_mobile);
						ternerobjuiguid.push(it.ui_guid);
						maintenancerlist.push(it.ui_realName);
					}
				});
			});

			this.trainbobjs.tr_maintenancerid = ternerobjuiguid.join(',');
			this.trainbobjs.tr_mobile = ternerobjmobile.join(',');
			this.trainbobjs.tr_maintenancer = maintenancerlist.join(',');
		},
		changeinms(file, fileList) {
			// this.imglist = fileList;
			// console.log("改变")
			this.handlePictureCardPreview(file);
		},
		successtrains(file, fileList) {
			// console.log("成功11111",file)
			this.handlePictureCardPreview(file);
		},
		handleRemove(file) {
			// console.log(file);
			let uploadFiles = this.$refs.pictureUpload.uploadFiles;
			if (file.percentage !== 0) {
				this.$confirm('确定删除这张图片吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.imglist.forEach((item, index) => {
							if (item.url == file.url) {
								uploadFiles.splice(index, 1);
							}
						});
						this.deletrainpicetch(file.sx_tp_guid);
					})
					.catch(() => {
						// console.log("有记录取消删除")
					});
			} else {
				this.imglist.forEach((item, index) => {
					if (item.url == file.url) {
						uploadFiles.splice(index, 1);
					}
				});
			}

			this.imglist = uploadFiles;

			// console.log(this.imglist)
		},

		handlePictureCardPreview(file) {
			if (file.percentage != 0) {
				this.imggnaes = file.sx_tp_originalName;
			} else {
				this.imggnaes = file.name;
			}

			if (file.url.match(/^blob:/i) !== null) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleimg = true;
				this.corappurl = '';
				this.dialogImageObj = file;
			} else {
				this.$message('当前图片无法修改，请重新上传新的图片');
				return;
			}
		},
		// 确定修改
		changeheadimg() {
			let uploadFiles = this.$refs.pictureUpload.uploadFiles;
			uploadFiles.forEach(item => {
				if (item.uid == this.dialogImageObj.uid) {
					item.raw = this.newfilenow;
					item.url = this.corappurl;
					this.imgslist.push(item);
				}
			});

			// this.$refs.pictureUpload.clearFiles(); //上传成功之后清除历史记录
			// this.$refs.pictureUpload.uploadFiles = uploadFiles;

			this.dialogVisibleimg = false;
		},
		// 截取图片
		// 真实图片
		realTime(data) {
			// console.log(data);
			let _this = this;
			this.$refs.cropper.getCropBlob(async data1 => {
				let formData = new FormData();
				if (data1) {
					var timestamp = new Date().getTime() + '.jpg';
					const newFile = new window.File([data1], timestamp);
					var src = window.URL.createObjectURL(newFile);
					_this.newfilenow = newFile;
					_this.corappurl = src;
				}
			});
		},

		macchanges() {
			var reg_name = /[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}/;
			var reg_name1 = /[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}/;
			if (reg_name.test(this.trainsbsobj.te_deviceMac) || reg_name1.test(this.trainsbsobj.te_deviceMac)) {
				this.ismacshow = false;
				// console.log("进入正确", reg_name1.test(this.trainsbsobj.te_deviceMac))
			} else {
				this.ismacshow = true;
				// console.log("进入正确", reg_name1.test(this.trainsbsobj.te_deviceMac))
			}
		},
		ipchanges() {
			var reg_name = /^((?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d))$/;
			// console.log(reg_name.test(this.trainsbsobj.te_deviceIp))
			if (!reg_name.test(this.trainsbsobj.te_deviceIp)) {
				this.isipshow = true;
			} else {
				this.isipshow = false;
			}
		},
		// 获取实训室
		getscoll() {
			getbfyGetTrainList(this.trainsbobj.si_guid).then(res => {
				// console.log(res, "实训室不分页")
				if (res.data.data.length > 0) {
					this.trainsnaameslist = res.data.data;
				} else {
					this.$message('暂无实训室');
					this.trainsnaameslist = [];
				}
			});
		},

		// 标签
		handleClose(tag) {
			this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
		},
		showInput() {
			this.inputVisible = true;
			this.$nextTick(() => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},
		handleInputConfirm() {
			let inputValue = this.inputValue;
			if (inputValue) {
				this.dynamicTags.push(inputValue);
			}
			this.inputVisible = false;
			this.inputValue = '';
		},

		// 删除实训室图片
		deletrainpicetch(tsxtpguid) {
			TrainDeleteTrainPic(tsxtpguid).then(res => {
				// console.log(res, "删除图片")
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		// 获取回显日期的数据
		dategetrtning() {
			// console.log(this.trainsbobj,"回显上")
			let ids = this.trainsbobj.sx_te_guid;
			GetscTrainingSetSingle(ids).then(res => {
				// console.log(res, "实训设备回显")
				if (res.data.data == null) {
					this.trainsbsobj.ap_reservedNum = 8;
					this.trainsbsobj.starttimer = '8:00';
					this.trainsbsobj.endtimer = '23:30';
				} else {
					this.tableData = JSON.parse(JSON.stringify(res.data.data.sxTimeconfiguration));
					this.ispassds = res.data.data.sx_te_AutoApprove;
					this.trainsbsobj.sxtsguid = res.data.data.sx_ts_guid;
					this.trainsbsobj.ap_reservedNum = res.data.data.sx_ts_number;
					this.trainsbsobj.starttimer = res.data.data.sx_ts_startTime;
					this.trainsbsobj.endtimer = res.data.data.sx_ts_endTime;
					this.checkList = res.data.data.sx_ts_trainCycle.split(',');
					this.oknumlist = res.data.data.sx_ts_trainCycle.split(',');
				}
			});
		},

		// 修改当前实训设备可预约日期
		InsertningSet() {
			let TrainingSetobj = {
				sx_te_guid: this.trainsbsobj.sx_te_guid,
				sx_ts_guid: this.trainsbsobj.sxtsguid,
				sx_ts_number: this.trainsbsobj.ap_reservedNum,
				sx_ts_startTime: this.trainsbsobj.starttimer,
				sx_ts_endTime: this.trainsbsobj.endtimer,
				sx_ts_trainCycle: this.checkList.join(','),
				sx_te_AutoApprove: this.ispassds,
				sxTimeconfiguration: this.tableData
			};
			InsertsbOrEditTrainingSet(TrainingSetobj).then(res => {
				if (res.data.code == 1) {
					// console.log(res)
					// this.$message({
					// 	message: '恭喜你，' + res.data.msg,
					// 	type: 'success'
					// });
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		// 删除单条实训室
		deletrains() {
			// let id = this.trainbobjs.sx_tr_guid
			getdgPageTrainDelete(this.trainbobjs.sx_tr_guid).then(res => {
				// console.log(res)
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.$router.go(-1);
				} else {
					this.$message(res.data.msg);
				}
			});
		},
		//  图片URL地址将图片转为可操作的File文件对象
		getImageFileFromUrl(url, imageName) {
			return new Promise((resolve, reject) => {
				var blob = null;
				var xhr = new XMLHttpRequest();
				xhr.open('GET', url);
				xhr.setRequestHeader('Accept', 'image/png');
				xhr.responseType = 'blob';
				// 加载时处理
				xhr.onload = () => {
					// 获取返回结果
					blob = xhr.response;
					let imgFile = new File([blob], imageName, { type: 'image/png' });
					// 返回结果
					resolve(imgFile);
				};
				xhr.onerror = e => {
					reject(e);
				};
				// 发送
				xhr.send();
			});
		},
		istimerblone() {
			for (let i = 0; i < this.tableData.length; i++) {
				let obj = this.tableData[i];

				let s_time = new Date(`1970-01-01T${obj.s_time}Z`); // 将 s_time 转换为时间戳
				let e_time = new Date(`1970-01-01T${obj.e_time}Z`); // 将 e_time 转换为时间戳
				// console.log(isNaN(s_time.getTime()), isNaN(e_time.getTime()), '时间111');
				if (isNaN(s_time.getTime()) || isNaN(e_time.getTime())) {
					// console.log('s_time or e_time is empty');
					this.$message('开始时间或结束时间为空');
					return false;
				}

				if (e_time < s_time) {
					// console.log('e_time is greater than s_time');
					this.$message('开始时间大于结束时间');
					return false;
				}

				if (i == this.tableData.length - 1) {
					return true;
				}
			}
		},
		// 保存修改实训室
		savetrains() {
			if (this.tableData.length == 0) {
				this.$message('请选择实训可预约时间');
				this.istabls = true;
				return;
			}
			if (!this.istimerblone()) {
				this.istabls = true;
				return;
			}
			this.istabls = false;
			if (this.name == '实训室') {
				// console.log(this.trainbobjs)
				var roomstrain = {
					sx_tr_guid: this.trainbobjs.sx_tr_guid,
					tr_name: this.trainbobjs.tr_name,
					tr_billNo: this.trainbobjs.tr_billNo,
					tr_maintenancer: this.trainbobjs.tr_maintenancer,
					tr_mobile: this.trainbobjs.tr_mobile,
					tr_openNum: this.trainbobjs.tr_openNum,
					tr_tag: this.dynamicTags.join('#'),
					tr_isOpen: this.radio == '1' ? true : false,
					tr_address: this.trainbobjs.tr_address,
					tr_introduction: this.trainbobjs.tr_introduction,
					tr_videoMonitoringURL: this.trainbobjs.tr_videoMonitoringURL,
					tr_remark: this.trainbobjs.tr_remark,
					si_guid: this.trainbobjs.si_guid,
					trainPicPath: '',
					tr_maintenancerid: this.trainbobjs.tr_maintenancerid,
					sx_te_AutoApprove: this.ispassds
				};

				let fromdata = new FormData();
				fromdata.append('sx_tr_guid', roomstrain.sx_tr_guid);

				fromdata.append('tr_name', roomstrain.tr_name);
				fromdata.append('tr_billNo', roomstrain.tr_billNo);
				fromdata.append('tr_maintenancer', roomstrain.tr_maintenancer);
				fromdata.append('tr_mobile', roomstrain.tr_mobile);
				fromdata.append('tr_openNum', roomstrain.tr_openNum);
				fromdata.append('tr_tag', roomstrain.tr_tag);
				fromdata.append('tr_isOpen', roomstrain.tr_isOpen);
				fromdata.append('tr_address', roomstrain.tr_address);
				fromdata.append('tr_introduction', roomstrain.tr_introduction);
				fromdata.append('tr_videoMonitoringURL', roomstrain.tr_videoMonitoringURL);
				fromdata.append('tr_remark', roomstrain.tr_remark);
				fromdata.append('si_guid', roomstrain.si_guid);
				fromdata.append('tr_maintenancerid', roomstrain.tr_maintenancerid);

				let imgslist = [];
				let filelist = [];
				this.$refs.pictureUpload.uploadFiles.forEach(item => {
					if (item.raw) {
						imgslist.push(item.raw);
					}
				});
				this.imgslist.forEach(ite => {
					if (ite.sx_tp_guid) {
						this.deletrainpicetch(ite.sx_tp_guid);
					}
				});

				for (let i = 0; i < imgslist.length; i++) {
					fromdata.append('filedata', imgslist[i]);
				}
				this.savetrainset();
				getAddTrain(fromdata).then(res => {
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.getrainsbs();
						this.gettainsinle();
					} else {
						this.$message(res.data.msg);
					}
				});
			} else {
				let tainobj = {
					sx_te_guid: this.trainsbsobj.sx_te_guid,
					te_deviceNumber: this.trainsbsobj.te_deviceNumber,
					te_deviceName: this.trainsbsobj.te_deviceName,
					te_maintenancer: this.trainsbsobj.te_maintenancer,
					te_deviceMac: this.trainsbsobj.te_deviceMac,
					te_tag: this.dynamicTags.join('#'),
					te_deviceIp: this.trainsbsobj.te_deviceIp,
					te_deviceIntroduction: this.trainsbsobj.te_deviceIntroduction,
					sx_tr_guid: this.trainsbsobj.sx_tr_guid,
					te_deviceRemark: this.trainsbsobj.te_deviceRemark,
					te_deviceState: this.radio,
					sx_te_AutoApprove: this.ispassds
				};
				this.InsertningSet();
				let from_data = new FormData();
				from_data.append('sx_te_guid', tainobj.sx_te_guid);
				from_data.append('te_deviceNumber', tainobj.te_deviceNumber);
				from_data.append('te_deviceName', tainobj.te_deviceName);
				from_data.append('te_maintenancer', tainobj.te_maintenancer);
				from_data.append('te_deviceMac', tainobj.te_deviceMac);
				from_data.append('te_tag', tainobj.te_tag);
				from_data.append('te_deviceIp', tainobj.te_deviceIp);
				from_data.append('te_deviceIntroduction', tainobj.te_deviceIntroduction);
				from_data.append('sx_tr_guid', tainobj.sx_tr_guid);
				from_data.append('te_deviceRemark', tainobj.te_deviceRemark);
				from_data.append('file', this.fileimgsb);
				from_data.append('te_deviceState', tainobj.te_deviceState);

				// console.log(tainobj, "保存")
				getUpdatetrainsb(from_data).then(res => {
					// console.log(res, "判断保存")
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						// this.InsertningSet();
						this.getraineginle();
						this.dategetrtning();
					} else {
						this.$message(res.data.msg);
					}
				});
			}
		},

		// 获取当前实训设备
		getraineginle() {
			getTrainEquipmentSingle(this.sxteguid).then(res => {
				// console.log(res, "设备")
				if (res.data.data) {
					this.trainsbobj = JSON.parse(JSON.stringify(res.data.data));
					this.trainsbsobj = JSON.parse(JSON.stringify(res.data.data));
					if (this.trainsbobj.te_tag != '') {
						// console.log("tag筛选")
						this.trainsbobj.te_tag = res.data.data.te_tag.split('#');
						this.dynamicTags = this.trainsbsobj.te_tag.split('#');
					}
					this.trainsbsobj.starttimer = '8:30';
					this.trainsbsobj.endtimer = '22:30';
					// console.log(this.trainsbsobj.te_tag.split("#"))
					this.getscoll();
					this.radio = this.trainsbsobj.te_deviceState + '';
					this.trainsnaames = this.trainsbsobj.sx_tr_name ?? '湖南高铁时代';
					this.trainsbsobj.sx_tr_name = this.trainsbsobj.sx_tr_name ?? '湖南高铁时代';

					let trainsbobjlistimg = [];

					if (this.trainsbobj.te_image != '') {
						this.sbimgs = res.data.data.te_image;
						this.tadins = 0;
						trainsbobjlistimg.push(this.sbimgs);
						this.trainsbobjlistimg = trainsbobjlistimg;
						// console.log("轮播有图", this.sbimgs)
					} else {
						this.tadins = 1;
						// console.log("轮播默认")
					}
					this.dategetrtning();
				} else {
					// this.$message("暂无数据")
					this.trainsbobj = [];
				}
			});
			// 获取当前子设备
			GetTrainEquipmentChildList(this.sxteguid).then(res => {
				// console.log(res, "子设备")
				this.trainsbcharen = res.data.data;
			});
		},

		// 点击上传
		clickrooms() {
			this.$refs.filrx.click();
		},
		clickroomsa() {
			this.$refs.filrxs.click();
		},
		getrainsbs(pageSize = 10) {
			// console.log(this.scoolid, "传递的id")

			let TrainEquipment = {
				sx_tr_guid: this.scoolid,
				te_deviceName: '',
				si_guid: this.siguid
			};
			TrainEquipment = {
				pageIndex: 1,
				pageSize: pageSize,
				si_guid: this.siguid,
				sx_tr_guid: this.scoolid,
				te_deviceName: ''
			};

			getPageTrainEquipmentList(TrainEquipment).then(res => {
				// console.log(res)
				this.trainsblist = res.data.data.list;
			});

			GetTrainingroomSetSingle(this.scoolid).then(res => {
				// console.log("实训室回显", res.data.data)
				if (res.data.data == null) {
					this.trainsbsobj.ap_reservedNum = 8;
					this.trainsbsobj.starttimer = '8:00';
					this.trainsbsobj.endtimer = '23:30';
				} else {
					this.tableData = JSON.parse(JSON.stringify(res.data.data.sxTimeconfiguration));
					this.trainsbsobj.sx_ts_guid = res.data.data.sx_ts_guid;
					this.trainsbsobj.ap_reservedNum = res.data.data.sx_ts_number;
					this.trainsbsobj.starttimer = res.data.data.sx_ts_startTime;
					this.trainsbsobj.endtimer = res.data.data.sx_ts_endTime;
					this.checkList = res.data.data.sx_ts_trainCycle.split(',');
					this.oknumlist = res.data.data.sx_ts_trainCycle.split(',');
					this.ispassds = res.data.data.sx_tr_AutoApprove;
				}
			});
		},

		gettainsinle() {
			getTrainSingle(this.scoolid).then(res => {
				// console.log(res, "接口给的实训室")
				this.trains = res.data.data;
				this.trainbobjs = JSON.parse(JSON.stringify(res.data.data));
				this.GetuserSelects();
				if (this.trainbobjs.tr_maintenancerid) {
					this.isshowmanid = this.trainbobjs.tr_maintenancerid.split(',');
				}

				// console.log(this.trainbobjs, "实训室")
				this.trainbobjs.PicList.forEach(item => {
					item.name = item.sx_tp_newName;
					item.url = item.sx_tp_imgPath;
				});
				this.imglist = this.trainbobjs.PicList;

				if (this.trains.tr_tag != '') {
					// console.log("tag筛选")
					this.trains.taglist = res.data.data.tr_tag.split('#');
					this.dynamicTags = this.trainbobjs.tr_tag.split('#');
				}

				this.trainbobjs.tp_status ? (this.radio = '1') : (this.radio = '2');
				this.tainglist = res.data.data.PicList == null ? new Array() : res.data.data.PicList;
				if (this.trains.PicList != null && this.trains.PicList.length > 0) {
					this.tadins = 0;
					// console.log("看看是否执行")
				} else {
					this.tadins = 1;
					// console.log("看看是否执行")
				}
			});
		},

		// 上传
		handleChange(e) {
			const file = e.target.files[0];
			let fromimgdata = new FormData();
			fromimgdata.append('sx_tr_guid', this.scoolid);
			fromimgdata.append('ph1', e.target.files[0]);
			TrainEditTrainImages(fromimgdata).then(res => {
				// console.log(res, "修改图片")
				if (res.data.msg == '操作成功') {
					let uploadimg = res.data.data;
					this.tainglist.push(uploadimg);
				} else {
					// this.$message(res.data.msg)
				}
			});
		},
		handleChangetsb(e) {
			const files = e.target.files[0];
			// this.fileimgsb = files;
			// this.tadins = 0;

			const base64 = getBase64(files);
			base64.then(res => {
				// console.log(res, "设备图片上传")
				this.trainsimg = res;
				this.dialogVisibletrainsimg = true;
			});
			// let formdata = new FormData();
			// formdata.append('file', files);
		},
		changeheadtrains() {
			// console.log(this.corappurl)
			this.sbimgs = this.corappurl;
			if (this.name == '实训设备') {
				this.tadins = 0;
			}

			this.trainsobjimgs = this.newfilenow;
			this.fileimgsb = this.newfilenow;

			this.dialogVisibletrainsimg = false;
		},
		trainsrealTime() {
			// console.log(data);
			let _this = this;
			this.$refs.trainscropper.getCropBlob(async data1 => {
				let formData = new FormData();
				if (data1) {
					var timestamp = new Date().getTime() + '.jpg';
					const newFile = new window.File([data1], timestamp);
					var src = window.URL.createObjectURL(newFile);
					_this.newfilenow = newFile;
					_this.corappurl = src;
				}
			});
		}
	},
	components: {
		titles,
		swiper,
		FullCalendar,
		VueCropper
	}
};
</script>

<style scoped lang="less">
.titlesdrawer {
	padding: 32px;
	font-size: 18px;
	color: #000;
	font-weight: 700;
	width: 100%;
	box-sizing: border-box;
}

.tablelistchioce {
	width: 90%;
	box-sizing: border-box;
	border: 1px solid #ccc;
	border-radius: 4px;
	padding: 10px 0;
	margin: 0 auto 20px;
	min-height: 300px;
	position: relative;
	button {
		width: 80px;
		height: 40px;
		color: #fff;
		background-color: #0acf97;
		position: absolute;
		bottom: 4px;
		right: 4px;
		border-radius: 4px;
		font-size: 15px;
	}

	.ismulitlist {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		padding-left: 10px;
		padding-right: 10px;

		p {
			margin-top: 10px;
			margin-right: 10px;
		}
	}
}

/deep/ .el-select {
	width: 100%;
}

.spalist {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	// #0acf97

	p {
		// width: 40px;
		height: 40px;
		color: #fff;
		background-color: red;
		border-radius: 4px;
		font-size: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 4px;
		cursor: pointer;
	}
}
</style>
